import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { constants } from '../../utitlity/constant';
// import { QuestionBase } from '../question-base';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, ControlContainer, NgForm } from '@angular/forms';

@Component({
    selector: 'ntb-calender',
    template: require('./calender.component.html'),
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class CalenderFieldComponent implements OnInit {
    @Input() question: any;
    @Input() questions: any = [];
    @Input() form: NgForm;
    // @Input() prefillData: any;
    fieldModel: any;
    startDate:any;
    endDate:any;
    startYear:any;
    endYear:any;
     defaultDate: any;

    // @Output() onNumberChange: EventEmitter<any> = new EventEmitter<any>();
    constructor() { }
    ngOnInit() {
        this.initializeCal();
    }

    initializeCal() {
        let date= new Date();
        let curYear= date.getFullYear();
        let start= new Date();
        let end= new Date();
        this.startYear = this.question['startDate'] ? curYear - parseInt(this.question['startDate']): curYear ; 
        this.endYear = this.question['endDate'] ? curYear + parseInt(this.question['endDate']) : curYear;
        start.setFullYear(this.startYear);
        end.setFullYear(this.endYear);
        this.startDate= start;
        this.endDate= end;
        this.defaultDate = this.endYear <= curYear ?  this.endDate : this.startDate;
    }
    onChangeTime($event: any, question) {
        question.value = this.convertTime($event);
    }
    convertTime(str: string) {
        let date = new Date(str);
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        var day = date.getDate();
        var year = date.getFullYear();
        var month = months[date.getMonth()];
        return day + '-' + month + '-' + year;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/components/calender/calender.component.ts